import { IConfig } from '@cian/config/shared';
import { BOOKING_ENTRY_POINT_SOURCES } from '../../constants/params';

export function isNewbuildingBrokerCianSource(cianSource: string, config: IConfig) {
  const newbuildingBrokerSources =
    config.get<string[]>('newbuilding-consultants-frontend.brokerSources') ?? BOOKING_ENTRY_POINT_SOURCES;

  return newbuildingBrokerSources.includes(cianSource);
}
